// extracted by css-extract-rspack-plugin
export default {"cls1":"Loading-cls1_eU5","cls2":"Loading-cls2_-Ja Loading-cls1_eU5"};